"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _ediFeedBack = require("@/api/bookSpace/ediFeedBack");
var _newManifestEDI = require("@/api/bookSpace/newManifestEDI");
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
var _cnTaoDeleteMsg = _interopRequireDefault(require("./components/cnTaoDeleteMsg"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "ediFeedBack",
  components: {
    sailSchedule: _SailScheduleOne.default,
    Pagination: _Pagination.default,
    cnTaoDeleteMsg: _cnTaoDeleteMsg.default
  },
  data: function data() {
    return {
      sailScheduleDialogVisible: false,
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 350px)',
        width: 'auto',
        overflow: 'hidden',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      tableData: [],
      total: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 10
      },
      blList: [],
      imoList: [],
      newHotTableSelections: [],
      cnTaoDeleteMsgDialogVisible: false,
      filterForm: {
        vesselCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: '',
        portCode: 'CNTAO',
        messageType: '',
        blNo: '',
        startDate: '',
        toDate: '',
        dataTime: []
      },
      rules: {
        // vesselFields: [
        //   {required: true, validator: this.validateVesselFields, trigger: 'blur'}
        // ],
        // blNo: [
        //   {required: true, validator: this.validateBlNo, trigger: 'blur'}
        // ],
        portCode: [{
          required: true,
          message: this.$t('userCenter.ediFeedBack.portCodeNotNull'),
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    validateNull: _validate.validateNull,
    loadDataByBLNo: function loadDataByBLNo(val) {
      // if (val) {
      //   this.loading = load()
      //   loadBookingHeadByBLNo(val).then(res => {
      //     if (res.success) {
      //       //this.filterForm.portCode = res.data.pol;
      //       this.filterForm.vesselCode = res.data.vesselCode;
      //       this.filterForm.voyageNo = res.data.voyageNo;
      //       this.filterForm.voyageLeg = res.data.voyageLeg;
      //     }
      //   }).finally(() => {
      //     this.loading.close()
      //   })
      // }
    },
    validateVesselFields: function validateVesselFields(rule, value, callback) {
      if (this.filterForm.vesselCode == '' && this.filterForm.voyageNo == '' && this.filterForm.voyageLeg == '') {
        callback(new Error(this.$t('userCenter.ediFeedBack.vesselAndVoyageNotNull')));
      } else {
        callback();
      }
    },
    validateBlNo: function validateBlNo(rule, value, callback) {
      if (this.filterForm.blNo == '') {
        callback(new Error(this.$t('userCenter.ediFeedBack.blNoNotEmpty')));
      } else {
        callback();
      }
    },
    handleDateRangeChange: function handleDateRangeChange(dates) {
      var _dates = (0, _slicedToArray2.default)(dates, 2),
        startDate = _dates[0],
        endDate = _dates[1];
      this.filterForm.startDate = startDate;
      this.filterForm.toDate = endDate;
    },
    handleSearch: function handleSearch() {
      var _this = this;
      if (this.filterForm.vesselCode == '' && this.filterForm.voyageNo == '' && this.filterForm.voyageLeg == '' && this.filterForm.blNo == '') {
        this.$message.error(this.$t('booking.blAgreementFr.vesselAndVoyageOrBlNoNotNull'));
        return;
      }
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this.loading = (0, _utils.load)();
          (0, _ediFeedBack.queryListReceipt)(_this.listQuery.currentPage, _this.listQuery.pageSize, _this.filterForm).then(function (res) {
            if (res.success) {
              _this.tableData = res.data.records;
              _this.total = res.data.totalRecord;
            }
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    },
    handleReset: function handleReset() {
      for (var key in this.filterForm) {
        this.filterForm[key] = '';
      }
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 10;
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.filterForm.vesselCode = row.vesselCode;
      this.filterForm.vesselName = row.vesselName;
      this.filterForm.voyageLeg = row.voyageLeg;
      this.filterForm.voyageNo = row.voyageNo;
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogType = 'search';
      this.sailScheduleDialogVisible = true;
    },
    sendFailureGuidebook: function sendFailureGuidebook() {
      var routeUrl = this.$router.resolve({
        path: '/bookingSpace/ediFeedBack/sendFailureGuidebook'
      });
      window.open(routeUrl.href, '_blank');
      //this.$router.push({path: '/bookingSpace/sendFailureGuidebook'})
    },
    cnTaoDeleteMessage: function cnTaoDeleteMessage() {
      var hotTableSelections = JSON.parse(JSON.stringify(this.$refs.hotTable.getSelections()));
      if (hotTableSelections.length < 1) {
        this.$message.error(this.$t('userCenter.ediFeedBack.checkOneData'));
        return;
      }
      this.newHotTableSelections = hotTableSelections.map(function (obj) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, obj), {}, {
          newVoyageNoLeg: obj.imoCode + ',' + obj.voyageNo + obj.voyageLeg
        });
      });
      this.cnTaoDeleteMsgDialogVisible = true;
    },
    init: function init() {
      if (!(0, _validate.validateNull)(this.$route.params)) {
        var blNo = this.$route.params.blNo;
        var portCode = this.$route.params.portCode;
        var vesselCode = this.$route.params.vesselCode;
        var voyageNo = this.$route.params.voyageNo;
        var voyageLeg = this.$route.params.voyageLeg;
        if ((0, _validate.validateNull)(blNo) && (0, _validate.validateNull)(portCode) && (0, _validate.validateNull)(vesselCode) && (0, _validate.validateNull)(voyageNo) && (0, _validate.validateNull)(voyageLeg)) return;
        if (!(0, _validate.validateNull)(blNo)) this.filterForm.blNo = this.$route.params.blNo;
        if (!(0, _validate.validateNull)(portCode)) this.filterForm.portCode = this.$route.params.portCode;
        if (!(0, _validate.validateNull)(vesselCode)) this.filterForm.vesselCode = this.$route.params.vesselCode;
        if (!(0, _validate.validateNull)(voyageNo)) this.filterForm.voyageNo = this.$route.params.voyageNo;
        if (!(0, _validate.validateNull)(voyageLeg)) this.filterForm.voyageLeg = this.$route.params.voyageLeg;
      } else if (!(0, _validate.validateNull)(this.$route.query)) {
        var _blNo = this.$route.query.blNo;
        var _portCode = this.$route.query.portCode;
        var _vesselCode = this.$route.query.vesselCode;
        var _voyageNo = this.$route.query.voyageNo;
        var _voyageLeg = this.$route.query.voyageLeg;
        if ((0, _validate.validateNull)(_blNo) && (0, _validate.validateNull)(_portCode) && (0, _validate.validateNull)(_vesselCode) && (0, _validate.validateNull)(_voyageNo) && (0, _validate.validateNull)(_voyageLeg)) return;
        if (!(0, _validate.validateNull)(_blNo)) this.filterForm.blNo = this.$route.query.blNo;
        if (!(0, _validate.validateNull)(_portCode)) this.filterForm.portCode = this.$route.query.portCode;
        if (!(0, _validate.validateNull)(_vesselCode)) this.filterForm.vesselCode = this.$route.query.vesselCode;
        if (!(0, _validate.validateNull)(_voyageNo)) this.filterForm.voyageNo = this.$route.query.voyageNo;
        if (!(0, _validate.validateNull)(_voyageLeg)) this.filterForm.voyageLeg = this.$route.query.voyageLeg;
      } else {
        return;
      }
      this.handleSearch();
    }
  },
  mounted: function mounted() {
    this.init();
  }
};